export class WinningPlan {
    amount: number;
    prices: WinningPlan.Price[] = [];
}

export module WinningPlan {
    export class Price {
        constructor(public hits: number, public odds: number) {
        }
    }
}


// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/winning-plan.ts